/**
 * Mapping between the määräaika controls and the two offset columns.
 *
 * calculate_due_date subtracts the offset from the anchor date, so a
 * positive value means "before". A set start offset always wins over an
 * end offset, which is why switching anchor writes null into the other
 * column rather than leaving it in place.
 */

export type DeadlineAnchor = "START" | "END";
export type DeadlineDirection = "BEFORE" | "AFTER";

export type DeadlineOffset =
  | { mode: "NONE" }
  | {
      mode: "SET";
      days: number;
      anchor: DeadlineAnchor;
      direction: DeadlineDirection;
    };

export function offsetFromColumns(
  start: number | null | undefined,
  end: number | null | undefined
): DeadlineOffset {
  if (start !== null && start !== undefined) {
    return {
      mode: "SET",
      days: Math.abs(start),
      anchor: "START",
      direction: start >= 0 ? "BEFORE" : "AFTER",
    };
  }
  if (end !== null && end !== undefined) {
    return {
      mode: "SET",
      days: Math.abs(end),
      anchor: "END",
      direction: end >= 0 ? "BEFORE" : "AFTER",
    };
  }
  return { mode: "NONE" };
}

export function offsetToColumns(o: DeadlineOffset): {
  startTimingOffsetDays: number | null;
  endTimingOffsetDays: number | null;
} {
  if (o.mode === "NONE") {
    return { startTimingOffsetDays: null, endTimingOffsetDays: null };
  }
  const signed = o.direction === "BEFORE" ? o.days : -o.days;
  return o.anchor === "START"
    ? { startTimingOffsetDays: signed, endTimingOffsetDays: null }
    : { startTimingOffsetDays: null, endTimingOffsetDays: signed };
}

export function deadlineLabel(o: DeadlineOffset): string {
  if (o.mode === "NONE") return "Ei määräaikaa";
  if (o.days === 0) {
    return o.anchor === "START" ? "Töiden alkupäivänä" : "Töiden loppupäivänä";
  }
  if (o.direction === "BEFORE") {
    return o.anchor === "START"
      ? `${o.days} päivää ennen töiden alkua`
      : `${o.days} päivää ennen töiden loppua`;
  }
  return o.anchor === "START"
    ? `${o.days} päivää töiden alun jälkeen`
    : `${o.days} päivää töiden lopun jälkeen`;
}
